import { useEffect, useState } from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
import { AvField, AvForm } from "availity-reactstrap-validation";
import { toast } from "react-toastify";
import Select from "react-select";
import { useSelector } from "react-redux";
import { Translate } from "../../../../Enums/Tranlate";
import AttendanceService from "../../../../../services/HRM/AttendanceService";

const EditAttendanceModal = ({
	addModal,
	setAddModal,
	setShouldUpdate,
	item,
}) => {
	const [formData, setFormData] = useState({
		employee: "",
		clocked_in: "",
		clocked_out: "",
		status: "",
	});
	const lang = useSelector((state) => state.auth.lang);
	const [loading, setLoading] = useState(false);
	const attendanceService = new AttendanceService();

	useEffect(() => {
		setFormData({
			...formData,
			id: item?.id,
			employee: {
				label: item?.employeeName,
				value: item?.employeeId,
			},
			status: item?.status,
		});
	}, []);

	const submit = (e) => {
		e.preventDefault();
		let data = {
			clockIn: `${new Date().toISOString().split("T")[0]}T${
				formData?.clocked_in
			}:00.000Z`,
			clockOut: `${new Date().toISOString().split("T")[0]}T${
				formData?.clocked_out
			}:00.000Z`,
			status: formData?.status,
		};

		setLoading(true);
		attendanceService
			.update(formData?.id, data)
			?.then((res) => {
				if (res && res?.status) {
					toast.success("Loan Added Successfully");
					setShouldUpdate((prev) => !prev);
					setAddModal();
				}
				setLoading(false);
			})
			.catch(() => setLoading(false));
	};

	return (
		<Modal
			className={lang === "en" ? "en fade" : "ar fade"}
			style={{ textAlign: lang === "en" ? "left" : "right" }}
			show={addModal}
			onHide={() => {
				setAddModal();
			}}>
			<AvForm className="form-horizontal" onValidSubmit={submit}>
				<Modal.Header>
					<Modal.Title>
						{Translate[lang]?.edit} {Translate[lang]?.attendance}
					</Modal.Title>
					<Button
						variant=""
						className="close"
						style={{
							right: lang === "en" ? "0" : "auto",
							left: lang === "ar" ? "0" : "auto",
						}}
						onClick={() => {
							setAddModal();
						}}>
						<span>&times;</span>
					</Button>
				</Modal.Header>
				<Modal.Body>
					<Row>
						<Col md={12} className="mb-3">
							<label className="text-label">{Translate[lang]?.employee}</label>
							<Select
								value={formData?.employee}
								name="employee"
								placeholder={Translate[lang]?.select}
								options={[]}
								isDisabled
							/>
						</Col>
						<Col md={12}>
							<AvField
								label={Translate[lang]?.clocked_in}
								type="time"
								placeholder={Translate[lang]?.clocked_in}
								bsSize="lg"
								name="clocked_in"
								validate={{
									required: {
										value: true,
										errorMessage: Translate[lang].field_required,
									},
								}}
								value={formData.clocked_in}
								onChange={(e) =>
									setFormData({ ...formData, clocked_in: e.target.value })
								}
							/>
						</Col>
						<Col md={12}>
							<AvField
								label={Translate[lang]?.clocked_out}
								type="time"
								placeholder={Translate[lang]?.clocked_out}
								bsSize="lg"
								name="clocked_out"
								validate={{
									required: {
										value: true,
										errorMessage: Translate[lang].field_required,
									},
								}}
								value={formData.clocked_out}
								onChange={(e) =>
									setFormData({ ...formData, clocked_out: e.target.value })
								}
							/>
						</Col>
					</Row>
					<Button
						variant="primary"
						className="w-100 mt-3"
						type="submit"
						disabled={loading}>
						{Translate[lang]?.edit}
					</Button>
				</Modal.Body>
			</AvForm>
		</Modal>
	);
};

export default EditAttendanceModal;
